import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  es: {
    translation: {
      "dashboard": "Tablero",
      "master_view": "Vista Maestra",
      "records": "Registros",
      "inspections": "Inspecciones",
      "shipping_tickets": "Tickets Embarque",
      "daily_log": "Registro Diario",
      "visits": "Visitas",
      "tours_news": "Recorridos y Novedades",
      "shipments": "Embarques",
      "receipts": "Recibos",
      "placed_seals": "Sellos Colocados",
      "broken_seals": "Sellos Rotos",
      "curtain_control": "Control Cortinas",
      "users": "Usuarios",
      "logout": "Cerrar sesión",
      "sync": "Sincronizar",
      "download_pdf": "Descargar PDF",
      "audit_report": "Reporte PDF",
      "welcome": "Bienvenido al Sistema Integral de Seguridad Patrimonial",
      "panel_master": "1. PANEL MAESTRO",
      "panel_sriuc": "2. PANEL SRIUC (ESPEJO)",
      "panel_bitacoras": "3. PANEL BITÁCORAS",
      "panel_config": "4. CONFIGURACIÓN",
      "new_record": "Nuevo",
      "cancel": "Cancelar",
      "save": "Guardar",
      "loading": "Cargando..."
    }
  },
  en: {
    translation: {
      "dashboard": "Dashboard",
      "master_view": "Master View",
      "records": "Records",
      "inspections": "Inspections",
      "shipping_tickets": "Shipping Tickets",
      "daily_log": "Daily Log",
      "visits": "Visits",
      "tours_news": "Tours & News",
      "shipments": "Shipments",
      "receipts": "Receipts",
      "placed_seals": "Placed Seals",
      "broken_seals": "Broken Seals",
      "curtain_control": "Curtain Control",
      "users": "Users",
      "logout": "Logout",
      "sync": "Sync",
      "download_pdf": "Download PDF",
      "audit_report": "Audit PDF",
      "welcome": "Welcome to the Comprehensive Patrimonial Security System",
      "panel_master": "1. MASTER PANEL",
      "panel_sriuc": "2. SRIUC PANEL (MIRROR)",
      "panel_bitacoras": "3. LOGS PANEL",
      "panel_config": "4. CONFIGURATION",
      "new_record": "New",
      "cancel": "Cancel",
      "save": "Save",
      "loading": "Loading..."
    }
  },
  zh: {
    translation: {
      "dashboard": "仪表板",
      "master_view": "主视图",
      "records": "记录",
      "inspections": "检查",
      "shipping_tickets": "运输票据",
      "daily_log": "每日日志",
      "visits": "访问",
      "tours_news": "巡检与新闻",
      "shipments": "装运",
      "receipts": "收据",
      "placed_seals": "放置印章",
      "broken_seals": "破损印章",
      "curtain_control": "窗帘控制",
      "users": "用户",
      "logout": "登出",
      "sync": "同步",
      "download_pdf": "下载 PDF",
      "audit_report": "审计 PDF",
      "welcome": "欢迎使用综合资产安全系统",
      "panel_master": "1. 主面板",
      "panel_sriuc": "2. SRIUC 面板 (镜像)",
      "panel_bitacoras": "3. 日志面板",
      "panel_config": "4. 配置",
      "new_record": "新",
      "cancel": "取消",
      "save": "保存",
      "loading": "加载中..."
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
